'use client';

import Link from 'next/link';
import { cn } from '@/lib/utils';
import { usePathname } from 'next/navigation';

interface NavLinkProps {
  label: string;
  href: string;
}

const NavLink = ({ label, href }: NavLinkProps) => {
  const pathname = usePathname().split('/');
  const pageLabel = label.toLocaleLowerCase().replace(' ', '-');
  const isActive =
    pathname.includes(pageLabel) || (pathname[1] === '' && label === 'Home');
  return (
    <li>
      <Link
        href={href}
        className={cn(
          'group relative whitespace-nowrap text-[1rem] xl:text-[1.125rem] 2xl:text-xl',
          isActive && 'font-semibold text-rm-primary-200'
        )}
      >
        {label}
        <div
          className={cn(
            'absolute inset-0 top-7 m-auto h-[3px] w-0 rounded-full bg-rm-neutral-400 transition-all duration-300',
            !isActive && 'group-hover:w-full',
            isActive && 'w-full bg-rm-primary-200'
          )}
        />
      </Link>
    </li>
  );
};

export default NavLink;
